import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import "./webviewAr.css";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { myDesignService, myExpariencesService } from "../../services";
import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Link,
  ListItemText,
} from "@mui/material";
import { Box, SpeedDial, SpeedDialAction, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ViewInAR from "../../assets/viewInAR.svg";
import queryString from "query-string";
import CryptoJs from "crypto-js";
import ShareIcon from "@mui/icons-material/Share";
import logoByAds from "../../assets/fazColor.png";
import fazLogo from "../../assets/fazColor.png";
import logoAds from "../../assets/logoArtDesignStory.png";
import HelpIcon from "@mui/icons-material/Help";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LinkIcon from "@mui/icons-material/Link";
import clsx from "clsx";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LaunchIcon from "@mui/icons-material/Launch";

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import InfoIcon from "@mui/icons-material/Info";
import InformationsDialog from "./InformationsDialog";
import { useLocation } from "react-router";
import { useViewport } from "../../helpers";

import { useTour } from "@reactour/tour";
import secureLocalStorage from "react-secure-storage";
import { objectSizeCameraPos } from "../../helpers/model-viewer-camera-position";

import design from "../../assets/previewMolding/design.png";
import oak from "../../assets/previewMolding/oak.png";
import versailles from "../../assets/previewMolding/versailles.png";
import versaillesblanc from "../../assets/previewMolding/versaillesblanc.png";
import white from "../../assets/previewMolding/white.png";
import wood from "../../assets/previewMolding/wood.png";
import { Assistant } from "@mui/icons-material";
import AIDialog from "../../components/dialog/AIDialog";

const PREFIX = "WebviewAr";

const classes = {
  main: `${PREFIX}-main`,
  topRoot: `${PREFIX}-topRoot`,
  center: `${PREFIX}-center`,
  loaderMargin: `${PREFIX}-loaderMargin`,
  root: `${PREFIX}-root`,
  webVrButton: `${PREFIX}-webVrButton`,
  activateARText: `${PREFIX}-activateARText`,
  openInAppButton: `${PREFIX}-openInAppButton`,
  helpIconButton: `${PREFIX}-helpIconButton`,
  shareIconButton: `${PREFIX}-shareIconButton`,
  favoriteIconButton: `${PREFIX}-favoriteIconButton`,
  customIconButton: `${PREFIX}-customIconButton`,
  customIconRapidAccess: `${PREFIX}-customIconRapidAccess`,
  customIconButtonContainer: `${PREFIX}-customIconButtonContainer`,
  logoByAds: `${PREFIX}-logoByAds`,
  logoAds: `${PREFIX}-logoAds`,
  webVrPoster: `${PREFIX}-webVrPoster`,
  backdrop: `${PREFIX}-backdrop`,
  notAvailableRoot: `${PREFIX}-notAvailableRoot`,
  marginBottom: `${PREFIX}-marginBottom`,
  iconButtonDots: `${PREFIX}-iconButtonDots`,
  iconButtonCopy: `${PREFIX}-iconButtonCopy`,
  dotsIcon: `${PREFIX}-dotsIcon`,
  browserTextColor: `${PREFIX}-browserTextColor`,
  lineHeightSpacing: `${PREFIX}-lineHeightSpacing`,
  verticalBar: `${PREFIX}-verticalBar`,
  mobileStepper: `${PREFIX}-mobileStepper`,
  disabledButtonBackground: `${PREFIX}-disabledButtonBackground`,
  iconSize: `${PREFIX}-iconSize`,
  customWatermarkContainer: `${PREFIX}-customWatermarkContainer`,
  externalLinksContainer: `${PREFIX}-externalLinksContainer`,
  externalLinkstextListStyle: `${PREFIX}-externalLinkstextListStyle`,
  vrContainer: `${PREFIX}-vrContainer`,
  opacityBackground: `${PREFIX}-opacityBackground`,
  opacityBackgroundContent: `${PREFIX}-opacityBackgroundContent`,
  opacityBackgroundDescStart: `${PREFIX}-opacityBackgroundDescStart`,
  opacityBackgroundDescEnd: `${PREFIX}-opacityBackgroundDescEnd`,
  opacityBackgroundExparienceTitle: `${PREFIX}-opacityBackgroundExparienceTitle`,
  opacityBackgroundImage: `${PREFIX}-opacityBackgroundImage`,
  opacityBackgroundIcon: `${PREFIX}-opacityBackgroundIcon`,
  fakeClickContainer: `${PREFIX}-fakeClickContainer`,
  dialogDesktopInfoContainer: `${PREFIX}-dialogDesktopInfoContainer`,
  dialogDesktopInfoSpacing: `${PREFIX}-dialogDesktopInfoSpacing`,
  maskRedirectionBarContainer: `${PREFIX}-maskRedirectionBarContainer`,
  moldingChoicesContainer: `${PREFIX}-moldingChoicesContainer`,
  sizeChoicesContainer: `${PREFIX}-sizeChoicesContainer`,
  moldingPreviewItem: `${PREFIX}-moldingPreviewItem`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.main}`]: {
    width: "100%",
    height: "calc(100vh - 150px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(66,66,66,.9490196078431372)",
  },

  [`& .${classes.topRoot}`]: {
    display: "flex",
    minHeight: "56px",
  },

  [`& .${classes.center}`]: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },

  [`& .${classes.loaderMargin}`]: {
    marginTop: "1rem",
  },

  [`&.${classes.root}`]: {
    overflow: "none",
  },

  [`& .${classes.webVrButton}`]: {
    backgroundColor: "rgba(211, 175, 95, 0.8)",
    color: "#434343",
    borderRadius: "4px",
    border: "none",
    position: "absolute",
    height: "48px",
    maxHeight: "48px",
    padding: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: "999",
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  [`& .${classes.activateARText}`]: {
    transform: "translateY(5px)",
    marginLeft: "0.5rem",
  },

  [`& .${classes.openInAppButton}`]: {
    position: "absolute",
    top: "8px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "90%",
    textTransform: "none",
  },

  [`& .${classes.helpIconButton}`]: {
    marginTop: "0.5rem",
    color: "#343434",
    backgroundColor: "rgba(211, 175, 95, 0.8)",
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {},
    "&:hover": {
      color: "#343434",
      backgroundColor: "rgba(211, 175, 95, 0.8)",
    },
  },

  [`& .${classes.shareIconButton}`]: {
    marginTop: "0.5rem",
    color: "#343434",
    backgroundColor: "rgba(211, 175, 95, 0.8)",
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {},
    "&:hover": {
      color: "#343434",
      backgroundColor: "rgba(211, 175, 95, 0.8)",
    },
  },

  [`& .${classes.favoriteIconButton}`]: {
    marginTop: "0.5rem",
    color: "#343434",
    backgroundColor: "rgba(211, 175, 95, 0.8)",
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {},
    "&:hover": {
      color: "#343434",
      backgroundColor: "rgba(211, 175, 95, 0.8)",
    },
  },

  [`& .${classes.customIconButton}`]: {
    color: "#343434",
    width: "48px",
    height: "48px",
    backgroundColor: "rgba(211, 175, 95, 0.8)",
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {},
    "&:hover": {
      color: "#343434",
      backgroundColor: "rgba(211, 175, 95, 0.8)",
    },
  },

  [`& .${classes.customIconRapidAccess}`]: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    objectFit: "cover",
    objectPosition: "center",
  },

  [`& .${classes.customIconButtonContainer}`]: {
    marginTop: "0.5rem",
    color: "#343434",
    width: "48px",
    height: "48px",
    zIndex: "10",
  },

  [`& .${classes.logoByAds}`]: {
    width: "50px",
    padding: "0.7rem",
    // height: '48px',
    position: "absolute",
    // backgroundColor: '#000',
    left: "1rem",
    top: "56px",
    // borderRadius: '50%',
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {
      left: "0",
      top: "56px",
    },
  },

  [`& .${classes.logoAds}`]: {
    width: "125px",
    position: "absolute",
    top: "1rem",
    left: "2rem",
    borderRadius: "10px",
    padding: "0.5rem",
    zIndex: "10",
    [theme.breakpoints.between("xs", "md")]: {
      left: "1rem",
      top: "1rem",
    },
  },

  [`& .${classes.webVrPoster}`]: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundImage: `url(${logoByAds})`,
    backgroundSize: "250px 250px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },

  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  [`& .${classes.notAvailableRoot}`]: {
    position: "absolute",
    backgroundColor: "#484848",
    width: "80vw",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "1rem",
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: "2rem",
  },

  [`& .${classes.iconButtonDots}`]: {
    padding: "0 0.5rem",
    transform: "translateY(-2px)",
  },

  [`& .${classes.iconButtonCopy}`]: {
    padding: "0.25rem",
    transform: "translateY(-2px)",
  },

  [`& .${classes.dotsIcon}`]: {
    color: "#484848",
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
  },

  [`& .${classes.browserTextColor}`]: {
    color: theme.palette.primary.main,
  },

  [`& .${classes.lineHeightSpacing}`]: {
    lineHeight: "1.6",
  },

  [`& .${classes.verticalBar}`]: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    bottom: "1rem",
    right: "1rem",
  },

  [`& .${classes.mobileStepper}`]: {
    backgroundColor: "#424242",
    height: "32px",
    flexGrow: 1,
    zIndex: 90,
  },

  [`& .${classes.disabledButtonBackground}`]: {
    color: theme.palette.primary.main,
    "&:disabled": {
      backgroundColor: "transparent",
    },
  },

  [`& .${classes.iconSize}`]: {
    width: "90px",
    height: "90px",
    objectFit: "cover",
    objectPosition: "center",
  },

  [`& .${classes.customWatermarkContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
  },

  [`& .${classes.externalLinksContainer}`]: {
    maxHeight: "400px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`& .${classes.externalLinkstextListStyle}`]: {
    textAlign: "center",
  },

  [`& .${classes.vrContainer}`]: {
    position: "relative",
  },

  [`& .${classes.opacityBackground}`]: {
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: 9999,
  },

  [`& .${classes.opacityBackgroundContent}`]: {
    display: "flex",
    flexDirection: "column",
    color: "white",
    height: "100%",
    padding: "0.5rem 1rem",
  },

  [`& .${classes.opacityBackgroundDescStart}`]: {
    margin: "2rem auto 0.25rem auto !important",
  },

  [`& .${classes.opacityBackgroundDescEnd}`]: {
    margin: "0 auto 1rem auto !important",
  },

  [`& .${classes.opacityBackgroundExparienceTitle}`]: {
    margin: "2rem auto 1.5rem auto !important",
    color: "#d3af5f !important",
  },

  [`& .${classes.opacityBackgroundImage}`]: {
    width: "100%",
    maxWidth: "650px",
    transform: "scale(0.8)",
    margin: "0 auto",
    borderRadius: "12px",
  },

  [`& .${classes.opacityBackgroundIcon}`]: {
    margin: "0 auto",
    width: "50px",
    height: "50px",
  },

  [`& .${classes.fakeClickContainer}`]: {
    display: "grid",
  },

  [`& .${classes.dialogDesktopInfoContainer}`]: {
    textAlign: "center",
  },

  [`& .${classes.dialogDesktopInfoSpacing}`]: {
    marginBottom: "0.5rem",
  },

  [`& .${classes.maskRedirectionBarContainer}`]: {
    display: "flex",
    flexDirection: "column",
  },

  [`& .${classes.moldingChoicesContainer}`]: {
    "& > div:first-of-type": {
      paddingBottom: "30px",
      position: "absolute",
      left: "3rem",
    },
    "& > button:first-of-type": {
      padding: 0,
    },
  },

  [`& .${classes.sizeChoicesContainer}`]: {
    "& > div:first-of-type": {
      paddingBottom: "28px",
      position: "absolute",
      left: "3rem",
    },
    "& > button:first-of-type": {
      padding: 0,
    },
  },

  //style for model-viewer's custom progress bar in webviewAr.css file
  [`& .${classes.moldingPreviewItem}`]: {
    width: "30px",
    height: "30px",
  },
}));

let step = 0;

// const test = [
//   {
//     _id: "64215a9d0a058939caa209d5",
//     id: 573,
//     frameId: 536,
//     label: "testVisibleTarget",
//     frameLabel: "testVisible",
//     blinklCampaign: "",
//     blinklProvider: "",
//     imageUrl: null,
//     imageBorderlessUrl:
//       "https://art-design-story-bucket-dev.s3.fr-par.scw.cloud/art-design-story/mda-images/myEye.png",
//     idExparience: "674439247410720f957d1714",
//     molding: "versailles",
//     size: "large",
//     arLink: "https://artdesignstory.page.link/VLhNxPGGD42Kinf98",
//     shortLink: "https://dev.fanart.zone/NeGeYf",
//   },
// ];

// const test = [
//   {
//     createdDate: "2023-03-27T08:56:48.030Z",
//     active: true,
//     visible: true,
//     _id: "64215a9d0a058939caa209d5",
//     row: 6,
//     column: 5,
//     type: "frame",
//     customPosition: {
//       position: { x: 0, y: 1.600000023841858, z: 0 },
//       rotation: { x: 0, y: 0, z: 0 },
//       scale: { x: 1, y: 1, z: 1 },
//     },
//     redirection: "",
//     molding: "versailles",
//     size: "small",
//     imageUrl:
//       "https://art-design-story-bucket-dev.s3.fr-par.scw.cloud/art-design-story/mda-images/1-public.jpg",
//     usdz: "https://ar-dev.s3.fr-par.scw.cloud/TESTESTESTESTEST/1686302916060-Michigan.usdz",
//     exparienceId: "624e9e7a5eedbc505587b7e2",
//     links: [],
//     externalLinks: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://fanart.zone/oIjsRd",
//     id: "64215a9d0a058939caa209d5",
//     isWebXrAI: true,
//     introductionAI: "je suis une marmotte des étoiles !",
//     isLiked: false,
//     statistics: { description: 0, scan: 0, link: 0, print: 0, like: 0 },
//     providerId: null,
//     campaignId: null,
//     description: {
//       translations: [
//         {
//           lang: "BR",
//           text: "o carro azul",
//         },
//         {
//           lang: "GB",
//           text: "the blue car",
//         },
//         {
//           lang: "ES",
//           text: "el coche azul",
//         },
//         {
//           lang: "GR",
//           text: "το μπλε αυτοκίνητο",
//         },
//         {
//           lang: "IT",
//           text: "l'auto blu",
//         },
//         {
//           lang: "JP",
//           text: "青い車",
//         },
//         {
//           lang: "CN",
//           text: "蓝车",
//         },
//       ],
//       initial: "la voiture bleu",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "64104ed4c490d57d56bf5c69",
//     row: 0,
//     column: 1,
//     type: "custom",
//     link: "https://ar-dev.s3.fr-par.scw.cloud/TESTESTESTESTEST/1678354158405-santa-optim.glb",
//     customPosition: {
//       position: { x: 0, y: 0, z: 0 },
//       rotation: { x: 0, y: 0, z: 0 },
//       scale: { x: 1, y: 1, z: 1 },
//     },
//     redirection: "",
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     isWebXrAI: true,
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://picsum.photos/200/300",
//         link: "https://picsum.photos/er",
//         title: "testo",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://picsum.photos/200/300",
//         link: "hthttps://picsum.photos/er",
//         title: "testi",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://picsum.photos/200/300",
//         link: "https://www.google.com",
//         title: "testu",
//       },
//     ],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/J6VfWe",
//     id: "64104ed4c490d57d56bf5c69",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "6409a43ac490d5e1f2bf1296",
//     link: "",
//     title: "",
//     campaignId: "e9a1991fe64c4b81b5cec7252aa55797a",
//     providerId: "fc5552066e334f508cb56d5cbdd36384",
//     buyable: false,
//     molding: "versailles",
//     size: "medium",
//     purchasePrice: 0,
//     description: {
//       _id: "6409a43ac490d5aa55bf1297",
//       translations: [],
//       initial: "",
//     },
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/-9gRLP",
//     imageUrl:
//       "https://ar-prod.s3.fr-par.scw.cloud/CHALLENGEMICHELETAR/edmond-michelet.jpg",
//     // imageUrl:
//     // "https://art-design-story-bucket-dev.s3.fr-par.scw.cloud/art-design-story/mda-images/1-public.jpg",
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//     ],
//     row: 0,
//     column: 5,
//     type: "frame",
//     rotation: "north",
//     id: "6409a43ac490d5e1f2bf1296",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "640efb45c490d51ecabf39d3",
//     row: 0,
//     column: 6,
//     type: "frame",
//     link: "",
//     title: "",
//     campaignId: null,
//     providerId: null,
//     buyable: false,
//     molding: "wood",
//     size: "medium",
//     purchasePrice: 0,
//     description: {
//       _id: "640efb45c490d58989bf39d4",
//       translations: [],
//       initial: "",
//     },
//     image: "testLandscape.jpeg",
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/fgyJhw",
//     rotation: "north",
//     imageUrl:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/testLandscape.jpeg",
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//     ],
//     id: "640efb45c490d51ecabf39d3",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "640f2530c490d510d1bf41cc",
//     link: "",
//     title: "",
//     campaignId: null,
//     providerId: null,
//     buyable: false,
//     molding: "design",
//     size: "medium",
//     purchasePrice: 0,
//     description: {
//       _id: "640f2530c490d54c5fbf41cd",
//       translations: [],
//       initial: "",
//     },
//     image: "testJpgSkybox.jpg",
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//     ],
//     imageUrl:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/testJpgSkybox.jpg",
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/loXzpX",
//     row: 0,
//     column: 7,
//     type: "frame",
//     rotation: "north",
//     id: "640f2530c490d510d1bf41cc",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "64103d82c490d539a9bf57c0",
//     link: "",
//     title: "",
//     campaignId: null,
//     providerId: null,
//     buyable: false,
//     molding: "design",
//     size: "medium",
//     purchasePrice: 0,
//     description: {
//       _id: "64103d82c490d5c7d7bf57c1",
//       translations: [],
//       initial: "",
//     },
//     image: "testHeightImage.jpg",
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//     ],
//     imageUrl:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/testHeightImage.jpg",
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/qk19Ig",
//     row: 0,
//     column: 8,
//     type: "frame",
//     rotation: "north",
//     id: "64103d82c490d539a9bf57c0",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
//   {
//     createdDate: "2023-03-06T17:43:29.323Z",
//     active: true,
//     visible: true,
//     guests: [],
//     _id: "64104255c490d57e55bf58e7",
//     link: "",
//     title: "",
//     campaignId: null,
//     providerId: null,
//     buyable: false,
//     molding: "design",
//     size: "medium",
//     purchasePrice: 0,
//     description: {
//       _id: "64104255c490d51b97bf58e8",
//       translations: [],
//       initial: "",
//     },
//     image: "avatar-823eadd19a6a282337441038017b5d67.jpg",
//     externalLinks: [
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650010636324-logoByAds.png",
//         link: "https://picsum.photos/az",
//         title: "test",
//       },
//       {
//         rapidAccess: true,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1650011025658-logoAds.png",
//         link: "https://picsum.photos/er",
//         title: "test123",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306488066-avatar-823eadd19a6a282337441038017b5d67.jpg",
//         link: "hthttps://picsum.photos/er",
//         title: "test12",
//       },
//       {
//         rapidAccess: false,
//         logo: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/1672306519186-globe.jpeg",
//         link: "https://www.google.com",
//         title: "tes1",
//       },
//     ],
//     imageUrl:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/avatar-823eadd19a6a282337441038017b5d67.jpg",
//     exparienceId: "613b827cc6999063ce888540",
//     links: [],
//     planif: [],
//     __v: 0,
//     shortLink: "https://dev.fanart.zone/RYopor",
//     row: 0,
//     column: 9,
//     type: "frame",
//     rotation: "north",
//     id: "64104255c490d57e55bf58e7",
//     arLink: "https://artdesignstory.page.link/gjn4mefhpxk6tWNeA",
//     exparienceLogo:
//       "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/cercle-trigonom%C3%A9trique.png",
//     name: "testestestestest",
//     hdr: "https://exparience-dev.s3.fr-par.scw.cloud/LIVE-TESTESTESTESTEST/WEB-XR-alps_field_4k.hdr",
//     contact: "hello@artdesignstory.fr",
//     statistics: {
//       createdDate: "2023-03-14T16:36:47.870Z",
//       _id: "6410a29fc490d545f6bf6b93",
//       exparienceId: "613b827cc6999063ce888540",
//       frameId: "64104ed4c490d57d56bf5c69",
//       type: "webview",
//       __v: 0,
//       id: "6410a29fc490d545f6bf6b93",
//     },
//   },
// ];

const WebviewAr = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const { width } = useViewport();
  const location = useLocation();
  const { isOpen, setIsOpen } = useTour();

  // size - molding
  const [mySize, setMySize] = useState(null);
  const [myMolding, setMyMolding] = useState(null);

  const [loaders, setLoaders] = useState({
    loading: true,
    loaded: "none",
    type: null,
  });
  const [fullConfig, setFullConfig] = useState(null);
  const [configuration, setConfiguration] = useState(null);
  const [lock, setLock] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [myPosition, setMyPosition] = useState(null);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [dimensions, setDimensions] = useState(null);
  const [srcModel, setSrcModel] = useState(null);
  const [navigationDisabled, setNavigationDisabled] = useState(false);
  const [state, setState] = useState({
    loaded: false,
    modelIsVisible: false,
    hasChanged: false,
  });
  const [camOrbit, setCamOrbit] = useState({
    min: "",
    max: "",
  });
  const [infoOnDesktop, setInfoOnDesktop] = useState(false);
  const [cameraOrbit, setCameraOrbit] = useState("100%");
  const [isProspectMode, setIsProspectMode] = useState(false);
  const [AIDialogOpen, setAIDialogOpen] = useState(false);

  const descriptionRef = useRef();

  useEffect(() => {
    descriptionRef.current = isDescriptionOpen;
  }, [isDescriptionOpen]);

  let createAndApplyTextureOnChange = async (channel) => {
    const tmpModel = document.getElementById("model-viewer");
    let painting = tmpModel?.model?.materials.filter((material) =>
      material.name.includes("content")
    )[0];
    if (
      (fullConfig[step]?.type !== "custom" && painting) ||
      (fullConfig[step]?.type === "custom" && fullConfig[step]?.imageUrl) ||
      !fullConfig[step].hasOwnProperty("type")
    ) {
      painting?.setAlphaMode("BLEND");
      const tmpUrl =
        loaders.type === "myDesign" && fullConfig[step].imageBorderlessUrl
          ? fullConfig[step].imageBorderlessUrl
          : fullConfig[step].imageUrl;
      const texture = await tmpModel.createTexture(
        loaders.type === "myDesign" ? tmpUrl : fullConfig[step].imageUrl
      );
      await painting.pbrMetallicRoughness[channel].setTexture(texture);
    }
  };

  const handleChangeModel = async () => {
    const tmpModel = document.getElementById("model-viewer");
    if (
      fullConfig[step]?.type !== "custom" ||
      (fullConfig[step]?.type === "custom" && fullConfig[step]?.imageUrl) ||
      !fullConfig[step].hasOwnProperty("type")
    ) {
      await createAndApplyTextureOnChange("baseColorTexture");
      setState({ ...state, hasChanged: false });
      setCameraOrbit(
        `0deg 90deg ${
          objectSizeCameraPos[fullConfig[step].size || fullConfig[step].type][
            isLandscape ? "landscape" : "portrait"
          ]
        }`
      );
    }
    //simulate click after changing the source to reset camera behavior
    tmpModel.click();
  };

  const handleNext = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setNavigationDisabled(true);
    document.getElementById("model-viewer").cameraTarget = "auto auto auto";
    document.getElementById("model-viewer").cameraOrbit = `0deg 90deg ${
      objectSizeCameraPos[fullConfig[step].size || fullConfig[step].type][
        isLandscape ? "landscape" : "portrait"
      ]
    }`;
    setCameraOrbit(
      `0deg 90deg ${
        objectSizeCameraPos[fullConfig[step].size || fullConfig[step].type][
          isLandscape ? "landscape" : "portrait"
        ]
      }`
    );
    const tmp = [...fullConfig];
    setState({ loaded: false, modelIsVisible: false, hasChanged: true });
    // si la source de model viewer ne change pas, l'eventListener Load n'est pas trigger, donc rappel à la fonction ici
    if (fullConfig[step + 1].imageUrl) {
      getImageDimensions(fullConfig[step + 1].imageUrl);
    } else {
      const tmpModel = document.getElementById("model-viewer");
      tmpModel.scale = "1 1 1";
      setSrcModel(fullConfig[step + 1].link);
      setCamOrbit({ min: "", max: "" });
    }
    setConfiguration(tmp[step + 1]);
    step = step + 1;
  };

  const handleBack = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setNavigationDisabled(true);
    document.getElementById("model-viewer").cameraTarget = "auto auto auto";
    document.getElementById("model-viewer").cameraOrbit = `0deg 90deg ${
      objectSizeCameraPos[fullConfig[step].size || fullConfig[step].type][
        isLandscape ? "landscape" : "portrait"
      ]
    }`;
    setCameraOrbit(
      `0deg 90deg ${
        objectSizeCameraPos[fullConfig[step].size || fullConfig[step].type][
          isLandscape ? "landscape" : "portrait"
        ]
      }`
    );
    const tmp = [...fullConfig];
    setState({ loaded: false, modelIsVisible: false, hasChanged: true });
    // si la source de model viewer ne change pas, l'eventListener Load n'est pas trigger, donc rappel à la fonction ici
    if (fullConfig[step - 1].imageUrl) {
      getImageDimensions(fullConfig[step - 1].imageUrl);
    } else {
      const tmpModel = document.getElementById("model-viewer");
      tmpModel.scale = "1 1 1";
      setSrcModel(fullConfig[step - 1].link);
      setCamOrbit({ min: "", max: "" });
    }
    setConfiguration(tmp[step - 1]);
    step = step - 1;
  };

  const decryptId = (id) => {
    const bytes = CryptoJs.AES.decrypt(
      id,
      process.env.REACT_APP_ENCRYPT_DECRYPT_KEY
    );
    return bytes.toString(CryptoJs.enc.Utf8);
  };

  const getImageDimensions = (imageUrl, tmpFull = null) => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = async () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const finalLandscape = imgWidth > imgHeight;
      let x = 1,
        y = 1,
        z = 1;
      if (imgWidth === imgHeight) {
        x = 1.34;
        y = 1;
        z = 1;
      } else if (imgWidth > imgHeight) {
        const ratio = imgWidth / imgHeight;
        x = ratio;
        y = 1.34;
        z = 1;
      } else {
        const ratio = imgHeight / imgWidth;
        x = 1;
        y = ratio / 1.34;
        z = 1;
      }
      if (tmpFull) {
        setSrcModel(
          `https://ar-prod.s3.fr-par.scw.cloud/0_FRAMES_AR/${
            tmpFull[step].molding
          }${finalLandscape ? "-landscape" : ""}${`${
            tmpFull[step].molding === "none"
              ? ""
              : `-${
                  tmpFull[step].size === "custom"
                    ? "large"
                    : !tmpFull[step].size
                    ? "medium"
                    : tmpFull[step].size
                }`
          }`}.glb`
        );
      } else {
        setSrcModel(
          `https://ar-prod.s3.fr-par.scw.cloud/0_FRAMES_AR/${
            fullConfig[step].molding
          }${finalLandscape ? "-landscape" : ""}${`${
            fullConfig[step].molding === "none"
              ? ""
              : `-${
                  fullConfig[step].size === "custom"
                    ? "large"
                    : !fullConfig[step].size
                    ? "medium"
                    : fullConfig[step].size
                }`
          }`}.glb`
        );
      }
      setIsLandscape(finalLandscape);
      setDimensions({ x, y, z });
      setCamOrbit({
        min: "-Infinity 22.5deg 0.5m",
        max: "Infinity 157.5deg 10m",
      });
    };
  };

  useEffect(() => {
    if (dimensions) {
      const tmp = document.getElementById("model-viewer");
      if (tmp?.src)
        tmp.scale = `${dimensions.x} ${dimensions.y} ${dimensions.z}`;
    }
  }, [dimensions]);

  // const getIp = () => {
  //   myDesignService
  //     .getIpFromDevice()
  //     .then((res) => {
  //       if (res.city) {
  //         // initializeTest(res.ip);
  //         initializeData(res.ip);
  //       } else {
  //         // initializeTest(null);
  //         initializeData(null);
  //       }
  //     })
  //     .catch((err) => {
  //       // initializeTest(null);
  //       initializeData(null);
  //     });
  // };

  useEffect(() => {
    initializeData(null);
    // initializeTest(null);
    if (secureLocalStorage && !secureLocalStorage.getItem("webviewTour"))
      setIsOpen(true);
    // getIp();
  }, []);

  // const initializeTest = async (myIp) => {
  //   if (!myIp) {
  //     navigator.geolocation.getCurrentPosition(
  //       function (position) {
  //         setMyPosition({
  //           coordinates: [position.coords.latitude, position.coords.longitude],
  //         });
  //       },
  //       function (error) {
  //         setMyPosition(error.message);
  //       }
  //     );
  //   }
  //   setIsProspectMode(true); // prospect mode to change molding and size with buttons
  //   setFullConfig([test]);
  //   setConfiguration(test);
  //   getImageDimensions(
  //     test.imageBorderlessUrl ? test.imageBorderlessUrl : test.imageUrl,
  //     [test]
  //   );
  //   setLoaders({
  //     ...loaders,
  //     loading: false,
  //     loaded: "done",
  //     type: "myDesign",
  //   });
  //   const testId = test.findIndex(
  //     (item) => item.id === "64215a9d0a058939caa209d5"
  //   );
  //   step = testId;
  //   let tmp = [...test].filter((item) => item.visible);
  //   const lastItem = { ...tmp[tmp.length - 1] };
  //   tmp.push(lastItem);
  //   setFullConfig(tmp);
  //   setConfiguration(test[testId]);
  //   if (test[testId].imageUrl) getImageDimensions(test[testId].imageUrl, tmp);
  //   else {
  //     setSrcModel(test[testId]?.link);
  //     setCamOrbit({ min: "", max: "" });
  //   }
  //   setLoaders({
  //     ...loaders,
  //     loading: false,
  //     loaded: "done",
  //     type: "exparience",
  //   });
  // };

  const initializeData = (myIp) => {
    if (!myIp) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setMyPosition({
            coordinates: [position.coords.latitude, position.coords.longitude],
          });
        },
        function (error) {
          if (error.code === 2)
            enqueueSnackbar(t("toasts.geolocationGetError"), {
              variant: "error",
            });
          setMyPosition(error.message);
        }
      );
    }
    const params = queryString.parse(location.search);
    if (params.targetId || params.exparienceId) setIsProspectMode(true);
    const tmp =
      params.targetId || params.exparienceId
        ? {
            type: "myDesign",
            id: params.targetId
              ? decryptId(params.targetId)
              : decryptId(params.exparienceId),
          }
        : params.configId
        ? { type: "exparience", id: decryptId(params.configId) }
        : null;
    if (tmp.type === "myDesign") {
      myDesignService
        .getArConfiguration(tmp.id, myIp)
        .then((res) => {
          setFullConfig([res]);
          setConfiguration(res);
          getImageDimensions(
            res.imageBorderlessUrl ? res.imageBorderlessUrl : res.imageUrl,
            [res]
          );
          setLoaders({
            ...loaders,
            loading: false,
            loaded: "done",
            type: "myDesign",
          });
        })
        .catch((err) => {
          setLoaders({ loading: false, loaded: "failed" });
          if (err === 403)
            enqueueSnackbar(t("toasts.unauthorizedError"), {
              variant: "error",
            });
          else
            enqueueSnackbar(t("toasts.getArConfigurationError"), {
              variant: "error",
            });
        });
    } else if (tmp.type === "exparience") {
      if (params.retrievalId) tmp.retrievalId = decryptId(params.retrievalId);
      myDesignService
        .getExparienceArConfiguration(tmp.id, myIp, tmp.retrievalId)
        .then((res) => {
          let tmpFull = [...res].filter((item) => item.visible);
          const lastItem = { ...tmpFull[tmpFull.length - 1] };
          tmpFull.push(lastItem);
          let currentId = tmpFull.findIndex((item) => item.id === tmp.id);
          if (currentId < 0) {
            currentId = 0;
          }
          step = currentId;
          setFullConfig(tmpFull);
          setConfiguration(tmpFull[currentId]);
          if (tmpFull[currentId].imageUrl)
            getImageDimensions(tmpFull[currentId].imageUrl, tmpFull);
          else {
            setSrcModel(tmpFull[currentId].link);
            setCamOrbit({ min: "", max: "" });
          }
          setLoaders({
            ...loaders,
            loading: false,
            loaded: "done",
            type: "exparience",
          });
        })
        .catch((err) => {
          setLoaders({ loading: false, loaded: "failed" });
          if (err === 403)
            enqueueSnackbar(t("toasts.unauthorizedError"), {
              variant: "error",
            });
          else
            enqueueSnackbar(t("toasts.getArConfigurationError"), {
              variant: "error",
            });
        });
    } else {
      setLoaders({ loading: false, loaded: "failed" });
    }
  };

  useEffect(() => {
    if (
      myPosition &&
      myPosition.hasOwnProperty("coordinates") &&
      fullConfig &&
      Array.isArray(fullConfig) &&
      fullConfig.length > 0
    ) {
      const tmp = {
        statistics: {
          ...fullConfig[0].statistics,
          position: myPosition,
          exparienceId: fullConfig[0].exparienceId,
          type: "webview",
        },
      };
      myExpariencesService
        .updateStatWebview(tmp)
        .then((res) => console.log("seen"));
    }
  }, [myPosition, fullConfig]);

  useEffect(() => {
    var standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iPad|iPhone|iPod/.test(userAgent);

    // if (userAgent.includes('instagram') || (userAgent.indexOf("FBAN") > -1 || userAgent.indexOf("FBAV") > -1) ||
    //   (!standalone && !safari && ios)) {
    //   setLock(true);
    // }
    if (
      userAgent.indexOf("FBAN") > -1 ||
      userAgent.indexOf("FBAV") > -1 ||
      (!standalone && !safari && ios) ||
      (ios && navigator.userAgent.indexOf("Snapchat") > -1)
    ) {
      setLock(true);
    }
  }, [navigator.userAgent]);

  useEffect(() => {
    const tmp = document.getElementById("model-viewer");
    if (!state.modelIsVisible) {
      const inter = setInterval(() => {
        if (tmp && tmp.modelIsVisible) {
          clearInterval(inter);
          setState({ ...state, modelIsVisible: true });
        }
      }, 200);
    }
    if (
      (state.modelIsVisible && state.loaded && state.hasChanged) ||
      (!state.loaded && state.modelIsVisible && tmp?.loaded && state.hasChanged)
    ) {
      handleChangeModel();
      setNavigationDisabled(false);
    }
  }, [state]);

  useEffect(() => {
    if (loaders.loaded === "done") {
      const tmp = document.getElementById("model-viewer");

      tmp.addEventListener("ar-status", (event) => {
        if (event.detail.status === "failed") {
          // if device is not compatible AR
          const error = document.getElementById("error");
          error.classList.remove("hide");
          error.addEventListener("transitionend", (event) => {
            error.classList.add("hide");
          });
        }
      });

      tmp.addEventListener("load", async () => {
        setState({
          loaded: tmp.loaded,
          modelIsVisible: tmp.modelIsVisible,
          hasChanged: true,
        });
      });

      const progress = document.querySelector("#progress");
      const bar = progress.querySelector(".bar");

      tmp.addEventListener("progress", (event) => {
        const { totalProgress } = event.detail;
        progress.classList.toggle("show", totalProgress < 1);
        bar.style.transform = `scaleX(${totalProgress})`;
      });

      //panning (relocate camera by touching/clicking)
      const tapDistance = 2;
      let panning = false;
      let panX, panY;
      let startX, startY;
      let lastX, lastY;
      let metersPerPixel;

      const startPan = () => {
        const orbit = tmp.getCameraOrbit();
        const { theta, phi, radius } = orbit;
        const psi = theta - tmp.turntableRotation;
        metersPerPixel = (0.75 * radius) / tmp.getBoundingClientRect().height;
        panX = [-Math.cos(psi), 0, Math.sin(psi)];
        panY = [
          -Math.cos(phi) * Math.sin(psi),
          Math.sin(phi),
          -Math.cos(phi) * Math.cos(psi),
        ];
        tmp.interactionPrompt = "none";
      };

      const movePan = (thisX, thisY) => {
        const dx = (thisX - lastX) * metersPerPixel;
        const dy = (thisY - lastY) * metersPerPixel;
        lastX = thisX;
        lastY = thisY;

        const target = tmp.getCameraTarget();
        target.x += dx * panX[0] + dy * panY[0];
        target.y += dx * panX[1] + dy * panY[1];
        target.z += dx * panX[2] + dy * panY[2];
        tmp.cameraTarget = `${target.x}m ${target.y}m ${target.z}m`;

        // This pauses turntable rotation
        tmp.dispatchEvent(
          new CustomEvent("camera-change", {
            detail: { source: "user-interaction" },
          })
        );
      };

      const recenter = (pointer) => {
        // lock recenter is reactour is opened
        if (!descriptionRef.current && !isOpen) {
          panning = false;
          if (
            Math.abs(pointer.clientX - startX) > tapDistance ||
            Math.abs(pointer.clientY - startY) > tapDistance
          )
            return;
          const hit = tmp.positionAndNormalFromPoint(
            pointer.clientX,
            pointer.clientY
          );
          tmp.cameraTarget =
            hit == null ? "auto auto auto" : hit.position.toString();
        }
      };

      tmp.addEventListener(
        "mousedown",
        (event) => {
          startX = event.clientX;
          startY = event.clientY;
          panning =
            event.button === 2 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey;
          if (!panning) return;

          lastX = startX;
          lastY = startY;
          startPan();
          event.stopPropagation();
        },
        true
      );

      tmp.addEventListener(
        "touchstart",
        (event) => {
          const { targetTouches, touches } = event;
          startX = targetTouches[0].clientX;
          startY = targetTouches[0].clientY;
          panning =
            targetTouches.length === 2 &&
            targetTouches.length === touches.length;
          if (!panning) return;

          lastX = 0.5 * (targetTouches[0].clientX + targetTouches[1].clientX);
          lastY = 0.5 * (targetTouches[0].clientY + targetTouches[1].clientY);
          startPan();
        },
        true
      );

      window.addEventListener(
        "mousemove",
        (event) => {
          if (!panning) return;

          movePan(event.clientX, event.clientY);
          event.stopPropagation();
        },
        true
      );

      tmp.addEventListener(
        "touchmove",
        (event) => {
          if (!panning || event.targetTouches.length !== 2) return;

          const { targetTouches } = event;
          const thisX =
            0.5 * (targetTouches[0].clientX + targetTouches[1].clientX);
          const thisY =
            0.5 * (targetTouches[0].clientY + targetTouches[1].clientY);
          movePan(thisX, thisY);
        },
        true
      );

      window.addEventListener(
        "mouseup",
        (event) => {
          recenter(event);
        },
        true
      );
    }
  }, [loaders.loaded]);

  const shareMedia = () => {
    navigator.share({
      title: document.title,
      text: `${t("myDesign.webVR.shareExparienceStart")}${
        configuration.label || configuration.displayName || configuration.name
      }${t("myDesign.webVR.shareExparienceEnd")}`,
      url: configuration.shortLink,
    });
  };

  const handleActivateAr = () => {
    document.getElementById("arButton").click();
  };

  const NotAvailableBackdrop = () => {
    const [clipboard, setClipboard] = React.useState({
      value: configuration?.shortLink,
      copied: false,
    });
    const testAndroid = /android/i.test(navigator.userAgent);
    const testIos =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const endDefaultBrowserText = testAndroid
      ? t("myDesign.webVR.androidOpenIn")
      : testIos
      ? t("myDesign.webVR.iOSopenIn")
      : "Unknown";
    const defaultBrowser = testAndroid
      ? "Google Chrome"
      : testIos
      ? "Safari"
      : "Unknown";
    return (
      <StyledDiv>
        <Backdrop className={classes.backdrop} open={lock}>
          <div className={classes.notAvailableRoot}>
            <div
              className={clsx(classes.marginBottom, classes.lineHeightSpacing)}
            >
              {t("myDesign.webVR.notAvailable")}
              <span className={classes.browserTextColor}>{defaultBrowser}</span>
              {t("myDesign.webVR.browser")}
            </div>
            <div
              className={clsx(classes.marginBottom, classes.lineHeightSpacing)}
            >
              {t("myDesign.webVR.toProceed")}
              <IconButton
                disabled
                className={classes.iconButtonDots}
                size="large"
              >
                <MoreVertIcon className={classes.dotsIcon} />
              </IconButton>
              {t("myDesign.webVR.iconPlacement")}
              <i className={classes.browserTextColor}>
                {endDefaultBrowserText}
              </i>
            </div>
            <div className={classes.lineHeightSpacing}>
              {t("myDesign.webVR.notDefaultBrowser")}
              {defaultBrowser}
              {t("myDesign.webVR.clickToCopy")}
              <CopyToClipboard
                onCopy={() => setClipboard({ ...clipboard, copied: true })}
                text={clipboard.value}
              >
                <IconButton
                  aria-label="copy link"
                  color="primary"
                  className={classes.iconButtonCopy}
                  onClick={(e) => {
                    enqueueSnackbar(t("toasts.copiedInClipboard"), {
                      variant: "info",
                    });
                    e.stopPropagation();
                  }}
                  size="large"
                >
                  <LinkIcon className={classes.dotsIcon} />
                </IconButton>
              </CopyToClipboard>
              {t("myDesign.webVR.pasteTheLink")}
              {defaultBrowser}.
            </div>
          </div>
        </Backdrop>
      </StyledDiv>
    );
  };

  const CustomIconsList = (props) => {
    return (
      <StyledDiv>
        <List disablePadding className={classes.externalLinksContainer}>
          {props.config.externalLinks.map((element, index) => (
            <React.Fragment key={`custom-watermark-${index + 1}`}>
              <Link href={element.link} target="_blank" color={"primary"}>
                <ListItem button className={classes.customWatermarkContainer}>
                  <ListItemIcon>
                    <img
                      className={classes.iconSize}
                      src={element.logo}
                      alt={`custom-watermark-icon-${index + 1}`}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={element.title}
                    className={classes.externalLinkstextListStyle}
                  />
                  <Button variant="outlined" color="primary">
                    {t("myDesign.webVR.visitCustomWatermarkButton")}
                  </Button>
                </ListItem>
              </Link>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </StyledDiv>
    );
  };

  const getModelViewerFormat = (params) => {
    // 48 if multi tableaux
    if (params.targetId && fullConfig?.length > 1) return "calc(100vh - 48px)";
    else if (params.targetId && !fullConfig?.length > 1) return "calc(100vh)";
    else {
      if (fullConfig?.length > 1) return "calc(100vh - 56px - 48px)";
      else return "calc(100vh - 56px)";
    }
  };

  const isAnyRapidAccessToFalse = (configuration) => {
    return configuration.externalLinks.some((item) => !item.rapidAccess);
  };

  const MoldingChoices = ({ molding, myMolding }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (!myMolding) setMyMolding(molding);
    }, [molding]);

    const actions = React.useMemo(
      () => [
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={design}
                alt="design molding"
              />
            </StyledDiv>
          ),
          name: "design",
        },
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={oak}
                alt="oak molding"
              />
            </StyledDiv>
          ),
          name: "oak",
        },
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={versailles}
                alt="versailles molding"
              />
            </StyledDiv>
          ),
          name: "versailles",
        },
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={versaillesblanc}
                alt="versaillesblanc molding"
              />
            </StyledDiv>
          ),
          name: "versaillesblanc",
        },
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={white}
                alt="white molding"
              />
            </StyledDiv>
          ),
          name: "white",
        },
        {
          icon: (
            <StyledDiv>
              <img
                className={classes.moldingPreviewItem}
                src={wood}
                alt="wood molding"
              />
            </StyledDiv>
          ),
          name: "wood",
        },
      ],
      []
    );

    const handleClose = () => {
      setOpen(false);
    };

    const handleOpen = () => {
      setOpen(true);
    };

    const handleChangeMolding = (action) => {
      setMyMolding(action.name);
      let splited = srcModel.split("-");
      let newMolding = splited[2].split("/");
      newMolding[newMolding.length - 1] = action.name;
      const joined = newMolding.join("/");
      splited[2] = joined;
      const newSrc = splited.join("-");
      setSrcModel(newSrc);
    };

    const getMoldingPreview = (myMolding) => {
      const tmp = actions.find((mold) => mold.name === myMolding);
      return tmp ? tmp.icon : "?";
    };

    return (
      <StyledDiv>
        <SpeedDial
          transitionDuration={0}
          ariaLabel="SpeedDial painting molding"
          onClose={handleClose}
          className={classes.moldingChoicesContainer}
          onClick={handleOpen}
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
          open={open}
          FabProps={{ variant: "extended" }}
          sx={{
            position: "absolute",
            bottom: 128,
            left: 16,
            width: 48,
            height: 48,
          }}
          icon={
            <Box sx={{ position: "relative" }}>
              {getMoldingPreview(myMolding)}
            </Box>
          }
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={(e) => {
                e.stopPropagation();
                handleChangeMolding(action);
                handleClose();
              }}
              FabProps={{
                style: {
                  margintop: "4rem",
                  backgroundColor: "#D3AF5F",
                  color: "#343434",
                },
              }}
            />
          ))}
        </SpeedDial>
      </StyledDiv>
    );
  };

  const SizeChoices = ({ size, mySize }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (!mySize) setMySize(size);
    }, [size]);

    const actions = [
      {
        icon: (
          <Box>
            <span>L</span>
          </Box>
        ),
        name: "small",
      },
      {
        icon: (
          <Box>
            <span>XL</span>
          </Box>
        ),
        name: "medium",
      },
      {
        icon: (
          <Box>
            <span>XXL</span>
          </Box>
        ),
        name: "large",
      },
    ];

    const getShortSize = (myText) => {
      return myText === "small"
        ? "L"
        : myText === "medium"
        ? "XL"
        : myText === "large"
        ? "XXL"
        : "?";
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleOpen = () => {
      setOpen(true);
    };

    const handleChangeSize = (action) => {
      setMySize(action.name);
      let splited = srcModel.split("-");
      let newSize = splited[splited.length - 1].split(".");
      newSize[0] = action.name;
      const joined = newSize.join(".");
      splited[splited.length - 1] = joined;
      const newSrc = splited.join("-");
      setSrcModel(newSrc);
    };

    return (
      <StyledDiv>
        <SpeedDial
          transitionDuration={0}
          ariaLabel="SpeedDial painting size"
          onClose={handleClose}
          className={classes.sizeChoicesContainer}
          onClick={handleOpen}
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
          open={open}
          FabProps={{ variant: "extended" }}
          sx={{
            position: "absolute",
            bottom: 64,
            left: 16,
            width: 48,
            height: 48,
          }}
          icon={
            <Box>
              <span>{getShortSize(mySize)}</span>
            </Box>
          }
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={(e) => {
                e.stopPropagation();
                handleChangeSize(action);
                handleClose();
              }}
              FabProps={{
                style: {
                  margintop: "4rem",
                  backgroundColor: "#D3AF5F",
                  color: "#343434",
                },
              }}
            />
          ))}
        </SpeedDial>
      </StyledDiv>
    );
  };

  // Model movement logic on vertical axis
  // const handleTouchStart = (event) => {
  //   if (event.touches.length === 1) {
  //     const touch = event.touches[0];
  //     modelViewerRef.current.dataset.initialX = touch.clientX;
  //     modelViewerRef.current.dataset.initialY = touch.clientY;
  //   } else if (event.touches.length === 2) {
  //     modelViewerRef.current.dataset.initialMidX =
  //       (event.touches[0].clientX + event.touches[1].clientX) / 2;
  //     modelViewerRef.current.dataset.initialMidY =
  //       (event.touches[0].clientY + event.touches[1].clientY) / 2;
  //   }
  // };

  // const handleTouchMove = (event) => {
  //   event.preventDefault(); // Prevent the default scroll and zoom actions
  //   if (event.touches.length === 1) {
  //     const touch = event.touches[0];
  //     const initialX = parseFloat(modelViewerRef.current.dataset.initialX);
  //     const initialY = parseFloat(modelViewerRef.current.dataset.initialY);
  //     const deltaX = touch.clientX - initialX;
  //     const deltaY = touch.clientY - initialY;

  //     // Apply translation in horizontal and forward/backward direction
  //     modelViewerRef.current.cameraOrbit = `${deltaX}deg ${deltaY}deg 100%`;
  //   } else if (event.touches.length === 2) {
  //     const midX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
  //     const midY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
  //     const initialMidY = parseFloat(
  //       modelViewerRef.current.dataset.initialMidY
  //     );
  //     const deltaY = midY - initialMidY;

  //     // Apply translation for vertical movement
  //     modelViewerRef.current.cameraOrbit = `auto auto calc(100% + ${deltaY}px)`;
  //   }
  // };

  // const handleTouchEnd = () => {
  //   modelViewerRef.current.dataset.initialX = "0";
  //   modelViewerRef.current.dataset.initialY = "0";
  //   modelViewerRef.current.dataset.initialMidX = "0";
  //   modelViewerRef.current.dataset.initialMidY = "0";
  // };

  if (loaders.loading) {
    return (
      <StyledDiv>
        <div className={classes.center}>
          <Typography variant="h3">{t("loaders.fetching")}</Typography>
          <CircularProgress size={50} className={classes.loaderMargin} />
        </div>
      </StyledDiv>
    );
  } else if (loaders.loaded === "failed" && !loaders.loading) {
    return (
      <StyledDiv>
        <div className={classes.center}>
          <NotAvailableBackdrop />
          <Typography variant="h3">{t("loaders.failed")}</Typography>
        </div>
      </StyledDiv>
    );
  } else {
    const params = queryString.parse(location.search);
    return (
      <StyledDiv>
        <Container disableGutters className={classes.root}>
          {isProspectMode && configuration?.type !== "custom" && (
            <>
              <MoldingChoices
                molding={configuration?.molding}
                myMolding={myMolding}
              />
              <SizeChoices size={configuration?.size} mySize={mySize} />
            </>
          )}
          <AIDialog
            open={AIDialogOpen}
            onClose={(e, reason) => {
              if (reason && reason === "backdropClick") return;
              setAIDialogOpen(false);
            }}
            configId={configuration.id}
            introductionAI={configuration.introductionAI}
            id={configuration.id}
          />
          <Dialog
            open={infoOnDesktop}
            onClose={() => setInfoOnDesktop(false)}
            aria-labelledby="alter-dialog-opened-on-desktop"
            aria-describedby="alter-dialog-opened-on-desktop-desc"
          >
            <DialogContent>
              <DialogContentText
                id="alter-dialog-opened-on-desktop-desc"
                className={classes.dialogDesktopInfoContainer}
              >
                <Typography
                  variant="body1"
                  className={classes.dialogDesktopInfoSpacing}
                >
                  {t("myDesign.webVR.desktopInfoMessage")}
                </Typography>
                <Typography variant="body1">
                  {t("myDesign.webVR.desktopInfoMessage2")}
                </Typography>
              </DialogContentText>
            </DialogContent>
          </Dialog>
          <InformationsDialog
            initialDesc={configuration?.description?.initial || ""}
            translations={configuration?.description?.translations || []}
            isDescriptionOpen={isDescriptionOpen}
            setIsDescriptionOpen={setIsDescriptionOpen}
          />
          <NotAvailableBackdrop />
          {fullConfig?.length > 1 && (
            <MobileStepper
              variant={fullConfig.length > 20 ? "text" : "dots"}
              steps={fullConfig.length}
              position="bottom"
              activeStep={step}
              className={classes.mobileStepper}
              id="mobileStepper"
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={
                    step === fullConfig.length - 1 || navigationDisabled
                  }
                  className={classes.disabledButtonBackground}
                >
                  {t("myDesign.webVR.nextButton")}
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              backButton={
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={step === 0 || navigationDisabled}
                  className={classes.disabledButtonBackground}
                  id="nextModel"
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                  {t("myDesign.webVR.backButton")}
                </Button>
              }
            />
          )}
          <img
            src={params.exparienceId || params.configId ? fazLogo : logoAds}
            alt="logo by artDesignStory"
            className={
              params.exparienceId || params.configId
                ? classes.logoByAds
                : classes.logoAds
            }
            style={{
              bottom:
                (params.exparienceId || params.configId) &&
                fullConfig?.length > 1
                  ? "calc(1rem + 48px)"
                  : (params.exparienceId || params.configId) &&
                    !(fullConfig?.length > 1)
                  ? "1rem"
                  : "none",
            }}
            onClick={() => {
              const url =
                params.exparienceId || params.configId
                  ? configuration.arLink || "https://app.fanartzone.com"
                  : "http://www.artdesignstory.fr";
              window.location.assign(url);
            }}
          />
          <div
            className={classes.verticalBar}
            style={{ paddingBottom: fullConfig?.length > 1 ? "48px" : 0 }}
          >
            <div
              id="redirectionsBar"
              className={classes.maskRedirectionBarContainer}
            >
              {configuration?.externalLinks?.length > 0 && (
                <>
                  {isAnyRapidAccessToFalse(configuration) && (
                    <>
                      <Drawer
                        anchor="bottom"
                        open={toggleDrawer}
                        onClose={() => setToggleDrawer(false)}
                      >
                        <CustomIconsList config={configuration} />
                      </Drawer>
                      <IconButton
                        className={classes.customIconButton}
                        onClick={
                          isOpen ? undefined : () => setToggleDrawer(true)
                        }
                        size="large"
                      >
                        <LaunchIcon />
                      </IconButton>
                    </>
                  )}
                  {configuration.externalLinks.map((item, index) => {
                    if (item.rapidAccess) {
                      return (
                        <div
                          className={classes.customIconButtonContainer}
                          key={`watermark-custom-icons-rapid-access-${
                            index + 1
                          }`}
                        >
                          <Link
                            href={item.link}
                            target="_blank"
                            color={"primary"}
                          >
                            <img
                              alt="Rapid Access Icon"
                              src={item.logo}
                              className={classes.customIconRapidAccess}
                            />
                          </Link>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                </>
              )}
              {configuration.isWebXrAI && (
                <IconButton
                  className={classes.shareIconButton}
                  style={{
                    marginTop:
                      configuration?.externalLinks?.length > 0 ? "0.5rem" : 0,
                    marginBottom:
                      configuration?.externalLinks?.length > 0 ? 0 : "0.5rem",
                  }}
                  onClick={isOpen ? undefined : () => setAIDialogOpen(true)}
                  size="large"
                >
                  <Assistant />
                </IconButton>
              )}
              <IconButton
                className={classes.shareIconButton}
                style={{
                  marginTop:
                    configuration?.externalLinks?.length > 0 ? "0.5rem" : 0,
                }}
                onClick={isOpen ? undefined : () => shareMedia()}
                size="large"
              >
                <ShareIcon />
              </IconButton>
              {configuration?.description?.initial && (
                <IconButton
                  className={classes.shareIconButton}
                  onClick={
                    isOpen
                      ? undefined
                      : () => {
                          setIsDescriptionOpen(true);
                        }
                  }
                  size="large"
                >
                  <InfoIcon />
                </IconButton>
              )}
              <a
                href={`mailto:${
                  configuration?.contact || "hello@artdesignstory.fr"
                }?subject=${configuration?.name || ""}`}
                target="_blank"
                rel="noreferrer"
              >
                <IconButton className={classes.helpIconButton} size="large">
                  <HelpIcon />
                </IconButton>
              </a>
            </div>
          </div>
          <button
            className={clsx(classes.webVrButton, "animated-button")}
            id="fakeArButton"
            style={{
              bottom: fullConfig?.length > 1 ? "4rem" : "1rem",
            }}
            onClick={isOpen ? undefined : () => handleActivateAr()}
          >
            <img id="ViewInAR" alt="ViewInAR-icon" src={ViewInAR} />
            <div className={classes.activateARText}>
              {t("myDesign.webVR.activateAR")}
            </div>
          </button>
          {(params.exparienceId || params.configId) && (
            <div className={classes.topRoot}>
              <Button
                className={classes.openInAppButton}
                variant="contained"
                color="primary"
                id="enterTheMetaverse"
                onClick={
                  width >= 1024
                    ? () => setInfoOnDesktop(true)
                    : () =>
                        window.location.assign(
                          configuration.webArAction &&
                            configuration.webArAction?.length > 0
                            ? configuration.webArAction
                            : configuration.arLink ||
                                "https://app.fanartzone.com"
                        )
                }
              >
                {t("myDesign.webVR.openInApp")}
              </Button>
            </div>
          )}
          <div className={classes.vrContainer}>
            {fullConfig?.length - 1 === step && loaders.type !== "myDesign" && (
              <div
                className={classes.opacityBackground}
                style={{
                  height: getModelViewerFormat(params),
                }}
              >
                <div className={classes.opacityBackgroundContent}>
                  <div
                    className={classes.fakeClickContainer}
                    onClick={() =>
                      window.location.assign(
                        configuration.arLink || "https://app.fanartzone.com"
                      )
                    }
                  >
                    <ArrowUpwardIcon
                      color="primary"
                      className={classes.opacityBackgroundIcon}
                    />
                    <Typography
                      variant="h5"
                      className={classes.opacityBackgroundDescStart}
                    >
                      {t("myDesign.webVR.continuationImmersion1")}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.opacityBackgroundDescEnd}
                    >
                      {t("myDesign.webVR.continuationImmersion2")}
                    </Typography>
                  </div>
                  <Typography
                    variant="h5"
                    className={classes.opacityBackgroundExparienceTitle}
                  >
                    {configuration.name}
                  </Typography>
                  <img
                    alt="Exparience Logo"
                    src={configuration.exparienceLogo}
                    className={classes.opacityBackgroundImage}
                  />
                </div>
              </div>
            )}
            <model-viewer
              src={srcModel}
              ios-src={configuration?.usdz || null}
              skybox-image={
                configuration?.hdr
                  ? configuration?.hdr
                  : "https://ar-poc.s3.fr-par.scw.cloud/test/360.hdr"
              }
              alt="EXP-AR-IENCE"
              ar
              autoplay
              ar-scale={isProspectMode ? "fixed" : "auto"} // lock the scale by pinch in AR
              shadow-intensity="1"
              ar-modes="webxr scene-viewer quick-look"
              camera-controls //enable user interaction
              ar-placement={configuration?.type === "custom" ? "floor" : "wall"}
              id="model-viewer"
              min-field-of-view="70deg"
              max-field-of-view="85deg"
              min-camera-orbit={camOrbit.min}
              max-camera-orbit={camOrbit.max}
              camera-orbit={cameraOrbit}
              style={{
                width: "100%",
                height: getModelViewerFormat(params),
                position: "relative",
              }}
            >
              <div
                id="lazy-load-poster"
                slot="poster"
                className={classes.webVrPoster}
              ></div>
              <button
                slot="ar-button"
                id="arButton"
                style={{ display: "none" }}
              />
              <div id="error" className="hide">
                {t("myDesign.webVR.ARNotSupported")}
              </div>
              <div id="progress" slot="progress-bar">
                <div class="bar"></div>
              </div>
            </model-viewer>
          </div>
        </Container>
      </StyledDiv>
    );
  }
};

export default WebviewAr;
